import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { LoadingAnimation } from '@/common-components/animations/loading/LoadingAnimation';
import {
  isNarrativeLoadingAtom,
  narrativeAtom,
} from '@/modules/claims/freeClaims/state';

/** Claim narrative only (insurance narrative). Clinical note is a separate section. */
export const ClaimNarrative = () => {
  const narrativeText = useAtomValue(narrativeAtom);
  const isLoading = useAtomValue(isNarrativeLoadingAtom);

  return (
    <div>
      <h2 className="vai-font-bold vai-text-lg" data-testid="narrative-title">
        <Trans>Claim Narrative</Trans>
      </h2>
      {isLoading ? (
        <LoadingAnimation isIconOnly data-testid="narrative-loading" />
      ) : (
        <div
          data-testid="narrative-text"
          className="vai-text-sm vai-whitespace-pre-wrap"
        >
          {narrativeText || 'None provided.'}
        </div>
      )}
    </div>
  );
};
